import { formatNumericValue } from 'utils/numbers'
import { CLUSTER_NAME } from 'utils/constants'
import { tpsAlertThreshold, tpsWarningThreshold } from './Status'

const Tps = ({ tps }: { tps: number }) => {
  if (CLUSTER_NAME == 'mainnet-beta') {
    return (
      <div>
        <div className="flex items-center">
          <StatusDot
            status={tps}
            alert={tpsAlertThreshold}
            warning={tpsWarningThreshold}
            isLessThan
          />
          <span className="font-mono text-xs text-th-fgd-2">
            {formatNumericValue(tps, 0)}
          </span>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default Tps

export const StatusDot = ({
  status,
  alert,
  warning,
  isLessThan,
}: {
  status: number
  alert: number
  warning: number
  isLessThan?: boolean
}) => {
  const greaterOrLessThan = (status: number, threshold: number) => {
    if (isLessThan) {
      return status < threshold
    } else return status > threshold
  }

  const dotColor = greaterOrLessThan(status, warning)
    ? 'bg-th-error'
    : greaterOrLessThan(status, alert)
      ? 'bg-th-warning'
      : 'bg-th-success'

  return (
    <div className="relative mr-1 size-3">
      <div
        className={`absolute left-0.5 top-0.5 size-2 rounded-full ${dotColor}`}
      />
      <div className={`absolute size-3 rounded-full opacity-40 ${dotColor}`} />
    </div>
  )
}
